export default __webpack_public_path__ + "static/media/dayplanner.6feedf54.png";